import { EditorOptions } from '@library/tableEditor/shared/editor.options';

import type { AtomModel } from '@models/atom.model';
import type { TableEditorTextColumnData } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

type Props = {
  atom: AtomModel<TableEditorTextColumnData>;
};

export const InputEditor = observer(({ atom }: Props) => (
  <EditorOptions
    atomId={atom.id}
    onPlaceholderChange={value =>
      (atom.data.editorOptions.editors.input.placeholder = value)
    }
    placeholder={atom.data.editorOptions.editors.input.placeholder}
  />
));
